'use client'
import React, { ReactNode, useEffect, useRef, useState } from 'react'
import { useInView } from 'react-intersection-observer'
import useScreenSize from '@/custom_hooks/useScreenSize'
import ScrollFade from '@/components/widgets/ScrollFade'
import SubHeader from '@/components/widgets/SubHeader'
import { useRouter } from 'next/navigation'
import UpperHeading from './UpperHeading'
import TagButton from './TagButton'
import Image from 'next/image'
import {
  ConnectionSpeed,
  useMeasureConnectionSpeed,
} from '@/custom_hooks/useMeasureConnectionSpeed'
import { useProductsByParam, useProductsPlacement } from '@/hooks/useProducts'
import { useUser } from '@/components/widgets/UserProvider'
import Loading from '@/components/widgets/Loading'
import { FetchProductParams } from '@/helpers/types/params_body/FetchProductParams'
import dynamic from 'next/dynamic'
import DesignCustom from '@/components/widgets/DesignCustom'
import { FeaturesSection } from './FeaturesSection'
import ExploreAllButton from '@/components/widgets/ExploreAllButton'
import ProductCardEveryDay from '@/components/widgets/ProductCardEveryDay'
import VertelierLove from '@/components/widgets/VertelierLove'
const CoupleSelectionCard = dynamic(() => import('./CoupleSelectionCard'), {
  ssr: false,
  loading: () => <Loading />,
})
const QuestionSection = dynamic(
  () => import('@/components/widgets/QuestionSection'),
  {
    ssr: false,
    loading: () => <Loading />,
  }
)
const CustomerStories = dynamic(
  () => import('@/components/widgets/CustomerStories'),
  {
    ssr: false,
    loading: () => <Loading />,
  }
)
const EssentialsContainer = dynamic(() => import('./ShopEssectials'), {
  ssr: false,
  loading: () => <Loading />,
})
const ProductGridWithVideo = dynamic(
  () => import('@/components/widgets/ProductGridWithVideo'),
  {
    ssr: false,
    loading: () => <Loading />,
  }
)
const VertelierExperienceEngagement = dynamic(
  () => import('@/components/widgets/VertelierExperienceEngagement'),
  {
    ssr: false,
    loading: () => <Loading />,
  }
)
const CalendlyEmbed = dynamic(
  () => import('@/components/widgets/CalendlyEmbed'),
  {
    ssr: false,
    loading: () => <Loading />,
  }
)
const EternityBandsHero = dynamic(
  () => import('../../engagement-page/engagement-page-widgets/EternityBands1'),
  {
    ssr: false,
    loading: () => <Loading />,
  }
)
const ProductCardGridWithVideo = dynamic(
  () => import('@/components/widgets/ProductCardGridWithVideo'),
  {
    ssr: false,
    loading: () => <Loading />,
  }
)

export const data = [
  {
    id: 1,
    status: 'BESTSELLER',
    type: 'Tennis Bracelet',
    name: 'Aster Tennis Bracelet',
    description: 'Pear cut, White, Rhodium plated metal.',
    price: '₹1,25,000.00',
    image: '/ic_ring2.png',
  },
  {
    id: 2,
    status: '',
    type: 'Aster Tennis Bracelet',
    name: 'Aster Tennis Bracelet',
    description: 'Pear cut, White, Rhodium plated metal.',
    price: '₹1,25,000.00',
    image: '/ic_bracelet.png',
  },
  {
    id: 3,
    status: 'IN STOCK',
    type: 'Tennis Bracelet',
    name: 'Aster Tennis Bracelet',
    description: 'Pear cut, White, Rhodium plated metal.',
    price: '₹1,25,000.00',
    image: '/ic_earing.png',
  },
  {
    id: 4,
    status: '',
    type: 'Marseille Diamond Hoop Earring',
    name: 'Aster Tennis Bracelet',
    description: 'Pear cut, White, Rhodium plated metal.',
    price: '₹1,25,000.00',
    image: '/ic_ring2.png',
  },
]

const NewLoveAffir = () => {
  const [videoUrl, setVideoUrl] = useState<string>('/home_page_banner_low.mp4')
  const [showBottomSection, setShowBottomSection] = useState(false)
  const [isMuted, setIsMuted] = useState(true)
  const [showGridSection, setShowGridSection] = useState(false)
  const isSmallScreen = useScreenSize(740)
  const bottomSectionTimeout = useRef<NodeJS.Timeout | null>(null)
  const gridSectionTimeout = useRef<NodeJS.Timeout | null>(null)
  const [isOpen, setOpen] = useState(false)
  const { speedCategory } = useMeasureConnectionSpeed()
  const { userPageLoading } = useUser()
  const router = useRouter()
  const videoRef = useRef<HTMLVideoElement>(null)
  // useEffect(() => {
  //   if (speedCategory) {
  //     let qualityUrl = ''

  //     switch (speedCategory) {
  //       case ConnectionSpeed.VERY_LOW:
  //         qualityUrl = '/home_page_banner_very_low.mp4'
  //         break
  //       case ConnectionSpeed.LOW:
  //         qualityUrl = '/home_page_banner_low.mp4'
  //         break
  //       case ConnectionSpeed.MEDIUM:
  //         qualityUrl = '/home_page_banner_medium.mp4'
  //         break
  //       case ConnectionSpeed.HIGH:
  //         qualityUrl = '/home_page_banner_high.mp4'
  //         break
  //       default:
  //         qualityUrl = '/home_page_banner_low.mp4'
  //     }

  //     setVideoUrl(qualityUrl)
  //   }
  // }, [speedCategory])
  useEffect(() => {
    if (speedCategory) {
      const qualityMap = {
        [ConnectionSpeed.VERY_LOW]: '/home_page_banner_very_low.mp4',
        [ConnectionSpeed.LOW]: '/home_page_banner_low.mp4',
        [ConnectionSpeed.MEDIUM]: '/home_page_banner_medium.mp4',
        [ConnectionSpeed.HIGH]: '/home_page_banner_high.mp4',
      }
      const selectedUrl =
        qualityMap[speedCategory] || '/home_page_banner_low.mp4'
      setVideoUrl(selectedUrl)
    }
  }, [speedCategory])

  // useEffect(() => {
  //   if (videoUrl || !isSmallScreen) {
  //     const bottomSectionDelay = isSmallScreen ? 3000 : 0
  //     const gridSectionDelay = isSmallScreen ? 5000 : 0

  //     if (bottomSectionTimeout.current) {
  //       clearTimeout(bottomSectionTimeout.current)
  //     }
  //     if (gridSectionTimeout.current) {
  //       clearTimeout(gridSectionTimeout.current)
  //     }

  //     bottomSectionTimeout.current = setTimeout(() => {
  //       setShowBottomSection(true)
  //     }, bottomSectionDelay)

  //     gridSectionTimeout.current = setTimeout(() => {
  //       setShowGridSection(true)
  //     }, gridSectionDelay)
  //   }

  //   return () => {
  //     if (bottomSectionTimeout.current) {
  //       clearTimeout(bottomSectionTimeout.current)
  //     }
  //     if (gridSectionTimeout.current) {
  //       clearTimeout(gridSectionTimeout.current)
  //     }
  //   }
  // }, [videoUrl, isSmallScreen])

  useEffect(() => {
    if (videoRef.current && videoUrl) {
      videoRef.current.load() // Force reload video with new source
      videoRef.current.play().catch(() => {
        // Handle autoplay failure (e.g., user interaction required)
        setIsMuted(true)
      })
    }

    const bottomSectionDelay = isSmallScreen ? 1000 : 0
    const gridSectionDelay = isSmallScreen ? 2000 : 0

    const bottomTimeout = setTimeout(
      () => setShowBottomSection(true),
      bottomSectionDelay
    )
    const gridTimeout = setTimeout(
      () => setShowGridSection(true),
      gridSectionDelay
    )

    return () => {
      clearTimeout(bottomTimeout)
      clearTimeout(gridTimeout)
    }
  }, [videoUrl, isSmallScreen])

  const { ref: engagementRef, inView: engagementInView } = useInView({
    triggerOnce: true,
  })

  // essentials
  const { ref: essentialsRef, inView: essentialsInView } = useInView({
    triggerOnce: true,
  })

  // customer stories
  const { ref: storiesRef, inView: storiesInView } = useInView({
    triggerOnce: true,
  })

  const fixedParamsForTopGrid: FetchProductParams = {
    subcategory: 'VERI',
    karat: '10',
  }

  const params: FetchProductParams = {
    // main_category: 'Rings',
    subcategory: 'VERI',
    karat: '14',
  }

  const [selectedItem, setSelectedItem] = useState('Rings')
  const [selectedParam, setSelectedParam] = useState(params)

  const { products: fixedTopProducts, isLoading: isLoadingTop } =
    useProductsByParam(fixedParamsForTopGrid, engagementInView)

  const { products: productList, isLoading } = useProductsByParam(
    selectedParam,
    engagementInView
  )

  const paramsForBottom: FetchProductParams = {
    // main_category: 'Earring',
    subcategory: 'VSPL4',
  }

  const paramsForBottom1: FetchProductParams = {
    // main_category: 'Earring',
    subcategory: 'VSPL42',
  }

  const {
    products: productListBottom,
    isLoading: isLoadingBottom,
    isError: errorBottom,
  } = useProductsByParam(paramsForBottom, essentialsInView)

  const {
    products: productListBottom1,
    isLoading: isLoadingBottom1,
    isError: errorBottom1,
  } = useProductsByParam(paramsForBottom1, storiesInView)

  const handleTouchToggleMute = () => {
    setIsMuted((prevState) => {
      const newState = !prevState
      return newState
    })
  }

  // const handleItemChange = (item: string) => {
  //   setSelectedItem(item)
  //   if (item === 'Rings') {
  //     setSelectedParam({ subcategory: 'VERI'})
  //   } else if (item === 'Earrings') {
  //     setSelectedParam({ subcategory: 'Instock', main_category: 'Earring',})
  //   } else if (item === 'Bracelets') {
  //     setSelectedParam({ subcategory: 'Instock', main_category: 'Bangles',})
  //   } else {
  //     setSelectedParam({ subcategory: 'Instock', main_category: item,})
  //   }
  // }
  const handleItemChange = (item: string) => {
    setSelectedItem(item)
    if (item === 'RINGS') {
      setSelectedParam({ subcategory: 'VERI', karat: '14' })
    } else if (item === 'EARRINGS') {
      setSelectedParam({
        subcategory: 'Instock',
        main_category: 'Earring',
        karat: '14',
      })
    } else if (item === 'BRACELETS') {
      setSelectedParam({
        subcategory: 'Instock',
        main_category: 'Bangles',
        karat: '14',
      })
    } else {
      setSelectedParam({
        subcategory: 'Instock',
        main_category: item,
        karat: '14',
      })
    }
  }

  return (
    <>
      {/* <div className='relative flex switch:hidden'>
        <div className='relative w-full'>
          <video
            ref={videoRef}
            autoPlay
            muted={isMuted}
            loop
            playsInline
            preload='auto' // Preload video
            src={videoUrl}
            onClick={handleTouchToggleMute}
            className='h-[calc(100vh-60px)] object-cover w-full'
            onContextMenu={(e) => e.preventDefault()}
            poster='/video_poster.jpg' // Add a poster image
          >
            <source src={videoUrl} type='video/mp4' />
            Your browser does not support the video tag.
          </video>

          <div className='md:hidden flex justify-center w-full my-[60px] absolute bottom-[20px]'>
            <button
              onClick={() =>
                router.push(`/product-listing?subcategory=Discover Collection`)
              }
              className='relative px-6 py-2 text-white border border-transparent group overflow-hidden'
            >
              <span className='absolute inset-0 flex items-center justify-start'>
                <span className='w-8 h-px bg-white'></span>
              </span>
              <div className='text-[16px] font-barlowMedium flex items-center gap-2 border-l border-solid border-white transition-all duration-300 group-hover:border group-hover:w-full group-hover:h-full group-hover:border-white p-2'>
                <span className='tracking-[5px]'>SHOP BESTSELLERS</span>
              </div>
            </button>
          </div>
        </div>

        <div className='hidden absolute top-0 left-0 bottom-0 right-0 h-full bg-gradient-to-t from-black via-black/70 to-transparent switch:flex pb-24 w-full justify-end flex-col'>
          <div className='flex flex-col items-center justify-center pt-5 md:pt-0 space-y-4'>
            <Image
              src='/ic_logo_white.svg'
              className='h-[104px] w-auto object-center'
              alt='Logo'
              width={104}
              height={104}
              loading='lazy'
            />
            <div className='max-w-[310px] px-5'>
              <UpperHeading
                title="LOVE'S FITNEST CREATIONS"
                spanText='AN ODE TO'
                minSize='24'
              />
            </div>
            <h2 className='underline text-sub-heading mb-lg:text-[14px] sm:text-[16px] md:text-[18px] tracking-[2px] font-barlowNormal'>
              SHOP <span className='font-barlowNormal'>ENGAGEMENT</span>
            </h2>
          </div>
        </div>
      </div> */}

      {showBottomSection ? (
        <>
          <div className='grid grid-cols-1 md:grid-cols-3 relative gap-10 mx-[15px] md:mx-[0px]'>
            {userPageLoading ? (
              <Loading
                classes={
                  'flex-grow flex relative max-h-screen sm:min-h-[645px] bg-[rgba(128,128,128,0.3)] !text-white'
                }
              />
            ) : (
              <div
                className='cursor-pointer w-full group min-h-[299px] mb-md:h-full sm:min-h-[480px] max-h-[299px] sm:max-h-[700px] relative transition-all duration-300'
                onClick={() =>
                  router.push(
                    '/product-listing?subcategory=Solitaire&main_category=Rings'
                  )
                }
              >
                <div className='relative w-full h-full'>
                  <Image
                    src='https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Home_Page/New_layout/Banners/Landing_banner1.webp'
                    alt=''
                    className='absolute inset-0 object-cover w-full h-full'
                    loading='lazy'
                    fill
                  />
                </div>
                {/* ✅ Gradient Overlay */}
                <div className='absolute inset-0 bg-gradient-to-t from-black/100 via-black/30 to-transparent' />
                <div className='absolute top-0 bottom-0 px-3 md:px-10 left-0 right-0 h-full w-full flex flex-col justify-end'>
                  <div className='!mb-[19px] md:!mb-[45px]'>
                    <div className='hidden switch:block'>
                      <UpperHeading
                        title='SHOP ENGAGEMENT RINGS'
                        position='start'
                        isHovered={true}
                        isOpenPage='/engagement'
                      />
                    </div>
                    <div className='block switch:hidden'>
                      <SubHeading text='SHOP' styledText='ENGAGEMENT' />
                    </div>
                    <p className='flex font-barlowMedium text-[16px] switch:text-[16px]'>
                      Timeless designs, handcrafted for your story.
                    </p>
                  </div>
                </div>
              </div>
            )}
            {userPageLoading ? (
              <Loading
                classes={
                  'flex-grow flex relative max-h-screen sm:min-h-[645px] bg-[rgba(128,128,128,0.5)] !text-white'
                }
              />
            ) : (
              <div
                onClick={() => router.push('/essential')}
                className='cursor-pointer w-full group h-[299px] sm:h-[480px] relative transition-all duration-300'
              >
                <div className='relative w-full h-full'>
                  <Image
                    src='https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Home_Page/New_layout/Banners/Landing_banner2.webp'
                    className='object-cover w-full h-full absolute inset-0'
                    alt=''
                    loading='lazy'
                    fill
                  />
                </div>
                <div className='absolute inset-0 bg-gradient-to-t from-black/100 via-black/30 to-transparent' />
                <div className='absolute top-0 bottom-0 left-0 px-3 md:px-10 right-0 h-full w-full flex flex-col justify-end '>
                  <div className='!mb-[19px] md:!mb-[45px]'>
                    <div className='hidden switch:block'>
                      <UpperHeading
                        title='SHOP ESSENTIALS'
                        position='start'
                        isHovered={true}
                        isOpenPage={'/essential'}
                      />
                    </div>
                    <div className='block switch:hidden'>
                      <SubHeading text='SHOP' styledText='WEDDING BANDS' />
                    </div>
                    <p className='flex font-barlowMedium  text-[16px] switch:text-[16px]'>
                      Everyday pieces you’ll wear on repeat.
                    </p>
                  </div>
                </div>
              </div>
            )}
            {userPageLoading ? (
              <Loading
                classes={
                  'flex-grow flex relative max-h-screen sm:min-h-[645px] bg-[rgba(128,128,128,0.5)] !text-white'
                }
              />
            ) : (
              <div
                onClick={() => router.push('/essential')}
                className='cursor-pointer w-full group h-[299px] sm:h-[480px] relative transition-all duration-300'
              >
                <div className='relative w-full h-full'>
                  <Image
                    src='https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Home_Page/New_layout/Banners/Landing_banner3.webp'
                    className='object-cover w-full h-full absolute inset-0'
                    alt=''
                    loading='lazy'
                    fill
                  />
                </div>
                <div className='absolute inset-0 bg-gradient-to-t from-black/100 via-black/30 to-transparent' />
                <div className='absolute top-0 bottom-0 left-0 px-3 md:px-10 right-0 h-full w-full flex flex-col justify-end '>
                  <div className='!mb-[19px] md:!mb-[45px]'>
                    <div className='hidden switch:block'>
                      <UpperHeading
                        title='THE TENNIS COLLECTION'
                        position='start'
                        isHovered={true}
                        isOpenPage={'/essential'}
                      />
                    </div>
                    <div className='block switch:hidden'>
                      <SubHeading text='SHOP' styledText='WEDDING BANDS' />
                    </div>
                    <p className='flex font-barlowMedium text-[16px] switch:text-[16px]'>
                      Bracelets and necklaces that never age.
                    </p>
                  </div>
                </div>
              </div>
            )}
            <div className='absolute hidden switch:hidden top-0 left-0 bottom-0 right-0 h-auto md:h-full w-full items-center justify-center'>
              <div className='flex flex-col items-center justify-center pt-5 md:pt-0 space-y-5'>
                <img
                  src='/ic_logo_gold.svg'
                  className=' h-[64px] md:h-[104px] w-auto object-center'
                  alt=''
                />
                <h1 className=' font-aesthetic text-[32px] sm:text-[50px] md:text-[64px] lg:text-[86px] sm:leading-[80px] leading-[30px] md:leading-[120px] text-[#E0B482]'>
                  WE ARE VERTELIER
                </h1>
              </div>
            </div>
          </div>
          {showGridSection ? (
            <div className=' w-full mt-[27px] switch:mt-section '>
              <div className=''>
                <ScrollFade>
                  <h1
                    className={`font-barlowMedium  text-center text-[16px]  md:text-[24px] lg:text-[36px] decoration-[1px] underline-offset-4 transition-[text-decoration-color] duration-300 hover:decoration-current mt-5`}
                  >
                    {/* <span className='font-barlowLight'>Say </span> */}
                    <span className='font-barlowSemibold'>Best Sellers </span>
                    {/* <span className='font-barlowLight'>
                      to Everlasting Love
                    </span> */}
                  </h1>
                </ScrollFade>
                <div className='mt-5'>
                  <ScrollFade>
                    {userPageLoading ? (
                      <Loading
                        classes={
                          'flex-grow flex relative max-h-screen sm:min-h-[45px] mx-[15%] mt-[25px] bg-[rgba(128,128,128,0.3)] !text-white'
                        }
                      />
                    ) : (
                      <h1 className='text-center block text-[#A08260] font-playfair  lg:leading-[83px] mb-md:text-[28px] text-[24px] md:text-[50px] lg:text-[64px] lg:px-32'>
                        Rings That Defy Convention
                      </h1>
                    )}
                  </ScrollFade>
                </div>
                {/* product sections */}

                <div className='flex justify-center'>
                  <ProductGridWithVideo
                    productList={
                      fixedTopProducts
                        ?.filter((item, index) => index % 2 !== 0)
                        .slice(0, 4) ?? []
                    }
                    isLoading={isLoadingTop}
                    theme='white'
                  />
                </div>

                {userPageLoading ? (
                  <Loading
                    classes={
                      'flex-grow flex relative max-h-screen sm:min-h-[35px] mx-[40%] mb-[20px] bg-[rgba(128,128,128,0.3)] !text-white rounded-[35px]'
                    }
                  />
                ) : (
                  <div className='flex justify-center lg:pb-8 pb-5 mt-5'>
                    {/* <TagButton
                      text='EXPLORE ALL'
                      onClick={() =>
                        router.push(
                          `/product-listing?subcategory=Designer&main_category=Rings`
                        )
                      }
                    /> */}
                    <ExploreAllButton
                      link={`/product-listing?subcategory=Designer&main_category=Rings`}
                    />
                  </div>
                )}
              </div>
              <DesignCustom />
              {/* couple section */}
              <div className='my-section'>
                {userPageLoading ? (
                  <>
                    <Loading
                      classes={
                        'flex-grow flex relative max-h-screen sm:min-h-[30px] mx-[30%] bg-[rgba(128,128,128,0.3)] !text-white'
                      }
                    />
                    <Loading
                      classes={
                        'flex-grow flex relative max-h-screen sm:min-h-[55px] my-[10px] mx-[20%] bg-[rgba(128,128,128,0.3)] !text-white'
                      }
                    />
                    <Loading
                      classes={
                        'flex-grow flex relative max-h-screen sm:min-h-[30px] mx-[30%] bg-[rgba(128,128,128,0.3)] !text-white'
                      }
                    />
                  </>
                ) : (
                  <ScrollFade>
                    <SubHeader>
                      <span>
                        <span className='font-barlow'>GENTLE</span>{' '}
                        <BarlowBoldText text='PROMISES' />
                      </span>
                    </SubHeader>

                    <h1 className=' font-cambonLight text-[24px] mb-lg:text-[26px] sm:text-[30px] switch:text-[40px] md:text-[50px] lg:text-[64px] text-[#A08260] text-center md:leading-[64px]'>
                      Rings that capture her heart
                    </h1>
                    <p className='hidden switch:block font-cambonExtraLight text-body mb-sm:text-body mb-md:text-[15px] mt-2 switch:mt-[20px] switch:text-[17px] md:text-[21px] w-full px-5 md:px-10 lg:px-0 text-center'>
                      Celebrate any moment with the Maison&apos;s selection of
                      exquisite creations.
                    </p>
                    <p className=' flex switch:hidden font-cambonExtraLight text-body mb-sm:text-body mb-md:text-[15px] mt-2 switch:mt-[30px] mb-lg:text-[17px] switch:text-[21px] w-full px-[5%] md:px-10 lg:px-0 lg:w-[75%] m-auto text-center'>
                      Celebrate any moment with the Maison&apos;s selection of
                      exquisite creations.
                    </p>
                  </ScrollFade>
                )}

                {userPageLoading ? (
                  <div className='flex m-[10px] gap-5'>
                    <Loading
                      classes={
                        'flex-grow flex relative max-h-screen sm:min-h-[345px] bg-[rgba(128,128,128,0.3)] !text-white'
                      }
                    />
                    <Loading
                      classes={
                        'flex-grow flex relative max-h-screen sm:min-h-[345px] bg-[rgba(128,128,128,0.3)] !text-white'
                      }
                    />
                    <Loading
                      classes={
                        'flex-grow flex relative max-h-screen sm:min-h-[345px] bg-[rgba(128,128,128,0.3)] !text-white'
                      }
                    />
                  </div>
                ) : (
                  <div className=' switch:space-x-4 w-full flex overflow-x-auto gap-1 ps-2 mb-lg:ps-0 mt-3 switch:mt-[32px]'>
                    <CoupleSelectionCard
                      gifImage='https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/MEGA/VERI0550/wv.mp4'
                      title='Solitaires'
                      actionButtonTitle='Shop Solitares'
                      onClick={() => {
                        router.push(
                          '/product-listing?subcategory=Solitaire&main_category=Rings'
                        )
                      }}
                    />
                    <CoupleSelectionCard
                      title='Three Stone'
                      gifImage='https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Home_Page/Three%20stone.mp4'
                      actionButtonTitle='Shop Three Stone'
                      onClick={() => {
                        router.push(
                          '/product-listing?subcategory=Three%20Stone'
                        )
                      }}
                    />
                    <CoupleSelectionCard
                      title='Hidden Halo'
                      gifImage='https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Home_Page/104.61.mp4'
                      actionButtonTitle='Shop Hidden Halo'
                      onClick={() => {
                        router.push(
                          '/product-listing?subcategory=Designer&main_category=Rings'
                        )
                      }}
                    />
                  </div>
                )}
              </div>
              <section className='w-full'>
                {/* Mobile Layout - Stacked */}
                <div className='md:hidden'>
                  {/* Header */}
                  <div className='text-center mb-4 p-4'>
                    <h2 className='font-barlowLight text-[20px] sm:text-[24px] tracking-[2px] mb-2'>
                      SHOP{' '}
                      <span className='font-barlowSemibold'>
                        EVERYDAY JEWELRY
                      </span>
                    </h2>
                  </div>

                  {/* Navigation Categories */}
                  {!userPageLoading && (
                    <div className='px-4 mb-6'>
                      {/* Mobile: Horizontal Scrollable Slider */}
                      <div className='block sm:hidden'>
                        <div className='flex overflow-x-auto scrollbar-hide gap-4 pb-2'>
                          {[
                            'RINGS',
                            'BRACELETS',
                            'EARRINGS',
                            'PENDANTS',
                            'NECKLACE',
                          ].map((item, index) => (
                            <button
                              className={`font-barlowSemibold text-[12px] uppercase leading-[100%] tracking-[3px] transition-all duration-300 hover:opacity-80 px-3 py-2 whitespace-nowrap flex-shrink-0 ${
                                selectedItem === item
                                  ? 'font-[600] opacity-100 border-b-2 border-blue-500'
                                  : 'opacity-70'
                              }`}
                              key={index}
                              onClick={() => handleItemChange(item)}
                            >
                              {item}
                            </button>
                          ))}
                        </div>
                      </div>

                      {/* Desktop: Original Layout */}
                      <div className='hidden sm:flex flex-wrap justify-between gap-2'>
                        {[
                          'RINGS',
                          'BRACELETS',
                          'EARRINGS',
                          'PENDANTS',
                          'NECKLACE',
                        ].map((item, index) => (
                          <button
                            className={`font-barlowMedium text-[14px] uppercase leading-[100%] tracking-[3px] transition-all duration-300 hover:opacity-80 px-2 py-1 ${
                              selectedItem === item
                                ? 'font-[600] opacity-100'
                                : 'opacity-70'
                            }`}
                            key={index}
                            onClick={() => handleItemChange(item)}
                          >
                            {item}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Image Section - Mobile */}
                  <div className='w-full h-[500px] sm:h-[400px] relative mb-6'>
                    {userPageLoading ? (
                      <Loading
                        classes={
                          'flex-grow flex relative max-h-screen h-[300px] sm:h-[400px] bg-[rgba(128,128,128,0.3)] !text-white rounded-none'
                        }
                      />
                    ) : (
                      <Image
                        src='https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/product_detail/Shop_evryday_banner.webp'
                        alt='Model wearing jewelry'
                        fill
                        className='object-cover object-top'
                        priority
                        sizes='100vw'
                      />
                    )}
                  </div>

                  {/* Product Grid - Mobile */}
                  <div className='px-4'>
                    {userPageLoading ? (
                      <div className='grid grid-cols-2 gap-2'>
                        {Array.from({ length: 4 }).map((_, index) => (
                          <Loading
                            key={index}
                            classes={
                              'flex-grow flex relative max-h-screen h-[300px] bg-[rgba(128,128,128,0.3)] !text-white rounded-none'
                            }
                          />
                        ))}
                      </div>
                    ) : (
                      <div ref={engagementRef} className='w-full'>
                        <ProductCardEveryDay
                          productList={productList ?? []}
                          isLoading={isLoading}
                          theme='black'
                        />
                      </div>
                    )}
                  </div>
                </div>

                {/* Desktop Layout - Side by Side */}
                <div className='hidden md:flex flex-row gap-4 min-h-[500px] md:min-h-[600px] p-4'>
                  {/* Left Section - Product Listing */}
                  <div className='flex-1 bg-black text-white w-full !min-w-[65%] lg:w-[65%] xl:w-[70%]'>
                    {userPageLoading ? (
                      <>
                        <Loading
                          classes={
                            'flex-grow flex relative max-h-screen sm:min-h-[45px] mx-[25%] bg-[rgba(128,128,128,0.3)] !text-white'
                          }
                        />
                        <div className='flex justify-around m-[10px] gap-[20px] mt-[20px]'>
                          <Loading
                            classes={
                              'flex-grow flex relative max-h-screen h-[30px] bg-[rgba(128,128,128,0.3)] !text-white'
                            }
                          />
                          <Loading
                            classes={
                              'flex-grow flex relative max-h-screen h-[30px] bg-[rgba(128,128,128,0.3)] !text-white'
                            }
                          />
                          <Loading
                            classes={
                              'flex-grow flex relative max-h-screen h-[30px] bg-[rgba(128,128,128,0.3)] !text-white'
                            }
                          />
                          <Loading
                            classes={
                              'flex-grow flex relative max-h-screen h-[30px] bg-[rgba(128,128,128,0.3)] !text-white'
                            }
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        {/* Header */}
                        <div className='text-center mb-4 md:mb-6'>
                          <h2 className='font-barlowLight text-[20px] sm:text-[24px] md:text-[32px] lg:text-[40px] xl:text-[48px] tracking-[2px] md:tracking-[4px] mb-2'>
                            SHOP{' '}
                            <span className='font-barlowSemibold'>
                              EVERYDAY JEWELRY
                            </span>
                          </h2>
                        </div>

                        {/* Navigation Categories */}
                        {!userPageLoading && engagementInView && (
                          <div className='flex flex-wrap justify-between gap-2 sm:gap-4 md:gap-6 lg:gap-8 mb-6 md:mb-8'>
                            {[
                              'RINGS',
                              'BRACELETS',
                              'EARRINGS',
                              'PENDANTS',
                              'NECKLACE',
                            ].map((item, index) => (
                              <button
                                className={`font-barlowMedium text-[12px] sm:text-[14px] md:text-[16px] lg:text-[20px] xl:text-[20px] uppercase leading-[100%] tracking-[3px] transition-all duration-300 hover:opacity-80 px-2 py-1 ${
                                  selectedItem === item
                                    ? 'font-[600] opacity-100'
                                    : 'opacity-70'
                                }`}
                                key={index}
                                onClick={() => handleItemChange(item)}
                              >
                                {item}
                              </button>
                            ))}
                          </div>
                        )}

                        {/* Product Grid */}
                        {userPageLoading ? (
                          <div className='grid grid-cols-2 lg:grid-cols-4 gap-2 md:gap-4'>
                            {Array.from({ length: 4 }).map((_, index) => (
                              <Loading
                                key={index}
                                classes={
                                  'flex-grow flex relative max-h-screen h-[300px] md:h-[400px] bg-[rgba(128,128,128,0.3)] !text-white rounded-none'
                                }
                              />
                            ))}
                          </div>
                        ) : (
                          <div ref={engagementRef} className='w-full'>
                            <ProductCardEveryDay
                              productList={productList ?? []}
                              isLoading={isLoading}
                              theme='black'
                            />
                          </div>
                        )}
                      </>
                    )}
                  </div>

                  {/* Right Section - Static Model Image - Desktop */}
                  <div className='w-[35%] xl:w-[30%] relative flex'>
                    {userPageLoading ? (
                      <Loading
                        classes={
                          'flex-grow flex relative max-h-screen h-full bg-[rgba(128,128,128,0.3)] !text-white rounded-none'
                        }
                      />
                    ) : (
                      <div className='relative w-full h-full flex-1'>
                        <Image
                          src='https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/product_detail/Shop_evryday_banner.webp'
                          alt='Model wearing jewelry'
                          fill
                          className='object-cover object-top'
                          priority
                          sizes='(max-width: 1024px) 35vw, 30vw'
                        />
                      </div>
                    )}
                  </div>
                </div>
              </section>

              <FeaturesSection />

              {/* <VertelierExperienceEngagement
                normalTitle='Vertelier'
                italicTitle='Promises'
                page='home'
              /> */}
              {/* Shop essentials*/}

              <EssentialsContainer
                productList={productListBottom?.slice(0, 4) ?? []}
              />

              <CustomerStories />
              {userPageLoading ? (
                <>
                  <Loading
                    classes={
                      'flex-grow flex relative max-h-screen mt-[25px] h-[585px] !bg-[rgba(128,128,128,0.3)] !text-white'
                    }
                  />
                </>
              ) : (
                // <div className=' hidden switch:block bg-white'>
                //   <div className='w-full bg-white sm:h-auto h-[300px] max-h-[650px] transition-all duration-200 relative justify-between'>
                //     <div className='flex flex-row justify-between items-center w-full'>
                //       <img
                //         src='https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Home_Page/image_diamond_left.svg'
                //         className='flex w-[230px] mb-md:w-[290px] mb-lg:w-auto switch:w-[365px] md:w-[465px] lg:w-[625px] h-full  -ml-[100px] mb-md:-ml-[80px] mb-lg:-ml-[70px] switch:-ml-[20px] md:-ml-[60px] opacity-100'
                //         alt=''
                //       />
                //       <img
                //         src='https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Home_Page/image_diamond_right.svg'
                //         className='flex w-[210px] mb-md:w-[260px] mb-lg:w-auto switch:w-[350px] md:w-[450px] lg:w-[600px] h-full -mr-[100px] mb-md:-mr-[80px] mb-lg:-mr-[70px] switch:-mr-[20px] md:-mr-[60px] opacity-100'
                //         alt=''
                //       />
                //     </div>
                //     <ScrollFade>
                //       <div className='h-full w-full text-black absolute top-0 left-0 right-0 bottom-0 flex justify-center items-center flex-col'>
                //         <h1 className=' text-[14px] mb-md:text-[16px] mb-lg:text-[22px] switch:text-[28px] md:text-[56px]  tracking-[5px] font-cambonLightItalic leading-[30px] switch:leading-[70px]'>
                //           Customization
                //         </h1>

                //         <h1 className=' font-barlowNormal mb-md:text-[13px] mb-lg:text-[15px] switch:text-[18px] md:text-[24px] leading-[32px] mt-1 switch:mt-3'>
                //           YOU NAME IT,{' '}
                //           <span className='font-barlowSemibold text-black'>
                //             WE MAKE IT.
                //           </span>
                //         </h1>
                //         <p className=' font-cambonLightItalic tracking-[1px] text-[#A08260] my-3 switch:my-5 pb-2 md:text-[20px] text-body lg:text-[24px] text-center'>
                //           From Bridal Necklaces <br />
                //           Rings <span className='font-cambonLight px-1'>
                //             |
                //           </span>{' '}
                //           Earrings{' '}
                //           <span className='font-cambonLight px-1'>|</span>{' '}
                //           Watches
                //         </p>
                //         <TagButton
                //           text='CUSTOMIZE YOUR JEWELARY'
                //           color='#330000'
                //         />
                //       </div>
                //     </ScrollFade>
                //     <ScrollFade>
                //       <div className='h-full w-full text-black absolute top-0 left-0 right-0 bottom-0 flex justify-center items-center flex-col'>
                //         <h1 className=' text-[14px] mb-md:text-[16px] mb-lg:text-[22px] switch:text-[28px] md:text-[56px]  tracking-[5px] font-cambonLightItalic leading-[30px] switch:leading-[70px]'>
                //           Customization
                //         </h1>

                //         <h1 className=' font-barlowNormal mb-md:text-[13px] mb-lg:text-[15px] switch:text-[18px] md:text-[24px] leading-[32px] mt-1 switch:mt-3'>
                //           YOU NAME IT,{' '}
                //           <span className='font-barlowSemibold text-black'>
                //             WE MAKE IT.
                //           </span>
                //         </h1>
                //         <p className=' font-cambonLightItalic tracking-[1px] text-[#A08260] my-3 switch:my-5 pb-2 md:text-[20px] text-body lg:text-[24px] text-center'>
                //           From Bridal Necklaces <br />
                //           Rings <span className='font-cambonLight px-1'>
                //             |
                //           </span>{' '}
                //           Earrings{' '}
                //           <span className='font-cambonLight px-1'>|</span>{' '}
                //           Watches
                //         </p>
                //         <TagButton
                //           text='CUSTOMIZE YOUR JEWELARY'
                //           color='#330000'
                //         />
                //       </div>
                //     </ScrollFade>
                //   </div>

                //   {/* <div className=" relative">
                //   <NextImage
                //     width={100}
                //     height={100}
                //     alt="Image"
                //     src={"/image_custom_bridal.svg"}
                //     className=" h-[525px] w-full hidden sm:flex object-cover"
                //   />
                //   <NextImage
                //     width={100}
                //     height={100}
                //     alt="Image"
                //     src={"/image_custom_bridal_one.svg"}
                //     className=" h-[430px] w-full object-cover flex sm:hidden"
                //   />
                //   <div className=" absolute h-full w-full lef-0 ps-[33%] pe-5 sm:pe-0 sm:ps-0  right-0 top-0 sm:top-[20%] flex justify-center sm:justify-start space-y-3 sm:space-y-5 flex-col items-start sm:items-center">
                //     <h1 className=" font-cambonRegular text-[#330000] sm:hidden flex text-heading mb-lg:text-[28px]">
                //       Custom{" "}
                //       <span className="font-cambonLightItalic">Bridal</span>
                //     </h1>
                //     <p className=" max-w-[904px] font-barlowNormal lg:text-[24px] px-0 sm:px-[5%] sm:text-[16px] md:text-[18px] text-body text-black mx-auto text-start sm:text-center">
                //       Lab-grown diamonds represent a shift towards more ethical
                //       consumption within the bridal jewellery market. Unlike
                //       mined diamonds, which often come with heavy environmental.
                //     </p>
                //     <TagButton text="SHOP CUSTOM BRIDAL" color="#330000" />
                //   </div>
                // </div> */}
                // </div>
                <EternityBandsHero
                  showLastBanner={false}
                  btnClick='/product-listing?main_category=Rings&subcategory=Wedding%20Bands'
                />
              )}
              {userPageLoading ? (
                <>
                  <Loading
                    classes={
                      'flex-grow flex relative max-h-screen mt-[25px] h-[585px] !bg-[rgba(128,128,128,0.3)] !text-white'
                    }
                  />
                </>
              ) : (
                <div className='flex flex-row h-[400px] md:h-[550px] lg:mt-0 mt-[40px]'>
                  <div className='w-[75%]'>
                    <img
                      src='https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Home_Page/three-girl-banner.webp'
                      className='w-full h-full lg:object-inherit object-cover lg:block hidden'
                    />
                    <img
                      src='https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Home_Page/three-girl-banner-homepage-mobile.webp'
                      className='w-full h-full lg:object-inherit object-cover lg:hidden block'
                    />
                  </div>
                  <div className="w-[25%] bg-[#7E7941] relative before:content-[''] before:absolute before:inset-0 before:bg-[url('/essyou/Essentially_you_standout_earring_bg_pattern.png')] before:bg-cover before:bg-center before:opacity-[0.12]">
                    <span className='uppercase absolute left-[70px] md:left-[110px] top-[0px] md:top-[-70px] rotate-90 transform origin-top-left translate-y-full text-[#013123] text-[30px] md:text-[52px] whitespace-nowrap font-cambonLight'>
                      Standout
                      <span className='font-cambonLight md:font-cambonLightItalic'>
                        {' '}
                        Earrings
                      </span>
                    </span>
                  </div>
                </div>
              )}
              {/* Bridal section */}
              {/* {userPageLoading ? (
                <>
                  <Loading
                    classes={
                      'flex-grow flex relative max-h-screen mt-[25px] h-[585px] !bg-[rgba(128,128,128,0.3)] !text-white'
                    }
                  />
                </>
              ) : (
                <div className='bg-white text-center w-full grid justify-center text-black lg:pb-0 pb-[80px]'>
                  <div>
                    <Image
                      src='/engagement/bridal-necklace-mobile.png'
                      alt='big_ring'
                      width={1440}
                      height={837}
                      className='md:hidden'
                    />

                    <Image
                      src='/engagement/bridal-necklace.png'
                      alt='big_ring'
                      width={1440}
                      height={837}
                      className='hidden md:block'
                    />
                  </div>

                  <div className='text-center'>
                    <span className='font-barlowSemibold font-[500] md:text-[24px] lg:text-[24px] xlg:text-[24px] text-[12px] uppercase leading-[14px] md:leading-[28.8px] lg:leading-[28.8px] xlg:leading-[28.8px] text-black'>
                      Every detail is sculpted
                    </span>
                  </div>

                  <div className='text-center'>
                    <span className='font-[400] text-[40px] md:text-[128px] lg:text-[128px] xlg:text-[128px] leading-[46.4px] md:leading-[148.48px] lg:leading-[148.48px] xlg:leading-[148.48px] text-[#330000] uppercase font-aboreto'>
                      Bridal
                    </span>
                  </div>

                  <div className='grid md:flex lg:flex xlg:flex justify-center gap-[24px]'>
                    <button
                      className='uppercase md:py-[9px] sm:py-[8px] py-[7px] lg:py-[11px] ps-[8px] pe-[15px] rounded-full border flex justify-center items-center group border-[#330000] text-[#330000]'
                      onClick={() => setOpen(true)}
                    >
                      <div className=' h-5 w-5  items-center justify-center flex'>
                        <div
                          className='h-1 w-1 rounded-full bg-white group-hover:w-5 group-hover:h-5 duration-300 ease-in-out justify-center items-center flex  group-hover:opacity-100 group-hover:translate-x-1'
                          style={{ backgroundColor: '#330000' }}
                        ></div>
                      </div>
                      <h1 className=' font-barlowSemibold tracking-widest ps-2 text-[11px] mb-sm:text-[12.5px] mb-md:text-[13.5px] mb-lg:text-[15px] lg:text-[16px]'>
                        Book an Appointment
                      </h1>
                    </button>

                    <button className='uppercase md:py-[9px] sm:py-[8px] py-[7px] lg:py-[11px] ps-[8px] pe-[15px] rounded-full border flex justify-center items-center group bg-[#330000] text-[#FFFFFF]'>
                      <div className=' h-5 w-5  items-center justify-center flex'>
                        <div
                          className='h-1 w-1 rounded-full bg-white group-hover:w-5 group-hover:h-5 duration-300 ease-in-out justify-center items-center flex  group-hover:opacity-100 group-hover:translate-x-1'
                          style={{ backgroundColor: '#FFFFFF' }}
                        ></div>
                      </div>
                      <h1 className=' font-barlowSemibold tracking-widest ps-2 text-[11px] mb-sm:text-[12.5px] mb-md:text-[13.5px] mb-lg:text-[15px] lg:text-[16px]'>
                        customize your jewelry
                      </h1>
                    </button>
                  </div>
                </div>
              )} */}
              {/* <div className='relative mt-[100px] flex lg:justify-end justify-center'>
                <img
                  src='/bridel-bg.jpg'
                  alt=''
                  className='bottom-0 left-0 absolute h-full w-auto hidden lg:block'
                />
                <div className='px-6 lg:border-r lg:border-l border-0 border-[#A08260] flex flex-col items-center justify-center'>
                  <img className='mx-auto' src='/rings-icn.png' alt='' />
                  <h1 className='font-cambonExtraLightItalic text-[#A08260] text-[24px] leading-[31px] md:text-[40px] md:leading-[50px] lg:text-[64px] lg:leading-[83px] text-center'>
                    “I take you” <br />
                    <span className=' font-cambonMediumItalic'>
                      Today & Always
                    </span>
                  </h1>
                  <p className='lg:hidden text-lg text-[#801C1A] mb-5'>
                    At Vertelier, we&apos;re here to help. We understand that
                    the best choices are often made with the heart, not the
                    price tag.
                  </p>
                  <h4 className='font-barlowLight tracking-[2.5px] text-[12px] mb-lg:text-[16px] switch:text-[24px] lg:text-[32px] uppercase lg:mt-12 mb-6'>
                    Rings that stands for <br />
                    <span className='text-[#791414] font-barlowMedium'>
                      love
                    </span>{' '}
                    in{' '}
                    <span className='text-[#791414] font-barlowMedium'>
                      all forms
                    </span>
                  </h4>
                  <div className='flex justify-center'>
                    <TagButton text='SHOP ETERNITY BANDS' color='#000' />
                  </div>
                </div>
                <div className='px-[5vw] max-w-[550px] relative hidden lg:block py-[50px]'>
                  <button className='swiper-button-prev absolute top-[225px] left-5'>
                    <img src='/engagement/arrow_left.png' alt='' />
                  </button>
                  <Swiper
                    spaceBetween={50}
                    slidesPerView={1}
                    loop
                    modules={[Navigation]}
                    navigation={{
                      nextEl: '.swiper-button-next',
                      prevEl: '.swiper-button-prev',
                    }}
                  >
                    {Array(4)
                      .fill(null)
                      .map((_, index) => (
                        <SwiperSlide key={index}>
                          <div className='text-left '>
                            <div>
                              <img
                                className='border border-[#A08260]'
                                src='/tennis-bracelet.jpg'
                                alt=''
                              />
                            </div>
                            <div>
                              <div className='flex flex-col justify-between flex-grow mt-3'>
                                <div className='flex flex-row h-[16px] justify-start space-x-[6px]'>
                                  <Image
                                    height={100}
                                    width={100}
                                    alt='Product image'
                                    src='/ic_jewelery_mauve.svg'
                                    className='w-[16px] h-[16px] p-0'
                                  />
                                  <Image
                                    height={100}
                                    width={100}
                                    alt='Product image'
                                    src='/ic_jewelery_gold.svg'
                                    className='w-[16px] h-[16px] p-0'
                                  />
                                  <Image
                                    height={100}
                                    width={100}
                                    alt='Product image'
                                    src='/ic_jewelery_silver.svg'
                                    className='w-[16px] h-[16px] p-0'
                                  />
                                </div>

                                <div className='flex flex-row h-[30px] justify-start w-full space-x-[6.2px] mt-2 items-center'>
                                  <JeweleryCategoryButton image='/ic_j_catergory_dark-1.png' />
                                  <JeweleryCategoryButton image='/ic_j_catergory_dark_2.png' />
                                  <JeweleryCategoryButton image='/ic_j_catergory_dark_3.png' />
                                  <JeweleryCategoryButton image='/ic_j_catergory_dark_4.png' />
                                  <JeweleryCategoryButton image='/ic_j_catergory_dark_5.png' />
                                  <JeweleryCategoryButton image='/ic_j_catergory_dark_6.png' />
                                </div>

                                <div>
                                  <div
                                    className={`text-[18px] font-barlowNormal mt-1 uppercase line-clamp-1 tracking-[1px] text-black`}
                                  >
                                    Tennis Bracelet
                                  </div>
                                  <p
                                    className={`font-barlowMedium text-[16px] pt-[2px] text-black`}
                                  >
                                    Pear cut, White, Rhodium plated metal.
                                  </p>
                                </div>
                                <div
                                  className={`text-[20px] font-cambonRegular mt-[6.5px]  text-black `}
                                >
                                  ₹1,25,000.00
                                </div>
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      ))}
                  </Swiper>
                  <button className='swiper-button-next absolute top-[225px] right-5'>
                    <img src='/engagement/arrow_right.png' alt='' />
                  </button>
                </div>
              </div> */}
              {/* <EternityBandsHero showLastBanner={false} /> */}
              {isOpen && (
                <div className='fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50'>
                  <div className='bg-white rounded-lg shadow-lg relative lg:w-[60%] w-[90%]'>
                    <button
                      onClick={() => setOpen(false)}
                      className='absolute top-3 right-3 bg-gray-200 p-1 rounded-full'
                    >
                      ✖
                    </button>
                    <br />
                    <CalendlyEmbed />
                  </div>
                </div>
              )}
              {/* customer stories section */}
              <div className='flex justify-center bg-white py-[40px]'>
                <ProductCardGridWithVideo
                  productList={productListBottom1 ?? []}
                  isLoading={isLoading}
                  theme='white'
                  section='custom'
                  justifyStyle='center'
                />
              </div>

              {/*
                isLoading={isLoading}
                  theme='white'
                  productList={productListBottom1?.slice(0, 4) ?? []}*/}
              {/* customization section */}

              <div className=' block switch:hidden bg-white mt-[24px]'>
                {/* <div className='w-full bg-white  switch:h-auto max-h-[650px] transition-all duration-200 relative justify-between'>
                  <div className='flex flex-row justify-between items-center w-full'>
                    <img
                      src='/image_diamond_left.svg'
                      className='flex w-[285px] sm:w-[365px] switch::w-[450px] lg:w-[600px] h-full  -ml-[100px] mb-md:-ml-[80px] mb-lg:-ml-[30px] switch:-ml-[20px] md:-ml-[60px] opacity-100'
                      alt=''
                    />
                    <img
                      src='/image_diamond_right.svg'
                      className='flex w-[270px]  sm:w-[350px] switch::w-[450px] lg:w-[600px] h-full -mr-[100px] mb-md:-mr-[80px] mb-lg:-mr-[30px] switch:-mr-[20px] md:-mr-[60px] opacity-100'
                      alt=''
                    />
                  </div>
                  <ScrollFade>
                    <div className='h-full w-full text-black absolute top-0 left-0 right-0 bottom-0 flex justify-center items-center flex-col'>
                      <h1 className=' text-heading mb-lg:text-[26px] switch:text-[28px] md:text-[56px]  tracking-[2px] font-cambonLightItalic leading-[30px] switch:leading-[70px]'>
                        Customization
                      </h1>

                      <h1 className=' hidden sm:block font-barlowNormal mb-md:text-[13px] mb-lg:text-[15px] switch:text-[18px] md:text-[24px] leading-[32px] mt-1 switch:mt-3'>
                        YOU NAME IT,{' '}
                        <span className='font-barlowSemibold text-black'>
                          WE MAKE IT.
                        </span>
                      </h1>
                      <p className=' font-cambonLightItalic tracking-[1px] text-[#A08260] my-3 switch:my-5 pb-2 md:text-[20px] text-body lg:text-[24px] text-center'>
                        From Bridal Necklaces <br />
                        Rings <span className='font-cambonLight px-1'>
                          |
                        </span>{' '}
                        Earrings{' '}
                        <span className='font-cambonLight px-1'>|</span> Watches
                      </p>
                      <div className='hidden sm:flex'>
                        <TagButton
                          text='CUSTOMIZE YOUR JEWELRY'
                          color='#330000'
                        />
                      </div>
                    </div>
                  </ScrollFade>
                </div> */}
                {/* </div> */}
                {/* essential section */}
                {/*
              <div className=' px-0 switch:px-5 md:px-10 lg:px-14 mt-[24px]'>
                <div className=" grid grid-cols-2 switch:grid-cols-3 switch:gap-3 md:gap-5 lg:gap-[24px] justify-between">
                  <div className=" col-span-2 h-full flex flex-col justify-end">
                    <ScrollFade>
                      <div className=" space-y-2 flex flex-col switch:items-start items-center">
                        <div className=" block switch:hidden">
                          <SubHeader>
                            <span>SHINE EFFORTLESSLY, EVERY DAY.</span>
                          </SubHeader>
                        </div>
                        <h1 className=" lg:text-[64px] text-heading mb-lg:text-[26px] sm:text-[28px] switch:text-[30px] md:text-[40px] font-cambonLight">
                          Essentially{" "}
                          <span className=" font-cambonLightItalic">Look</span>
                        </h1>
                        <div className=" hidden switch:block">
                          <SubHeader>
                            <span>SHINE EFFORTLESSLY, EVERY DAY.</span>
                          </SubHeader>
                        </div>
                        <p className=" font-barlowNormal text-[#EAE8DC] switch:text-start text-center switch:px-0 px-[5%] pb-4 text-body switch:text-[16px] max-w-[400px] switch:max-w-[782px] lg:text-[24px]">
                          Centered around you,offering savoir-faire diamond
                          jewelry without the inflated prices.
                        </p>
                        <TagButton
                          text="SHOP THE COLLECTION"
                          onClick={() => router.push(`/shop-the-look`)}
                        />
                      </div>
                    </ScrollFade>
                    <div className=" relative mt-10 block switch:hidden group">
                      <NextImage
                        width={100}
                        height={100}
                        alt="Image"
                        src={"/image_tennis_nexklace.svg"}
                        className=" h-[334px] w-full object-cover"
                      />
                      <div className=" absolute left-0 right-0 bottom-0 h-[20%] transition-all duration-200 group-hover:h-full w-full bg-gradient-to-t from-black to-transparent flex flex-col justify-end ps-5 pb-2">
                        <UnderlinedSubHeading>
                          <span>
                            SHOP <BarlowBoldText text="TENNIS NECKLACE" />
                          </span>
                        </UnderlinedSubHeading>
                      </div>
                    </div>
                    <div className=" grid grid-cols-2 switch:gap-3 md:gap-5 lg:gap-[24px] w-full relative mt-5">
                      <div className=" hidden switch:flex relative group">
                        <NextImage
                          width={100}
                          height={100}
                          alt="Image"
                          src={"/image_tennis_nexklace.svg"}
                          className=" h-[300px] break:h-[406px] w-full object-cover"
                        />
                        <div className=" absolute left-0 right-0 bottom-0 h-[20%] group-hover:h-full transition-all duration-200 w-full bg-gradient-to-t from-black to-transparent flex flex-col justify-end ps-2 switch:ps-5 pb-5">
                          <UnderlinedSubHeading>
                            <span>
                              SHOP <BarlowBoldText text="TENNIS NECKLACE" />
                            </span>
                          </UnderlinedSubHeading>
                        </div>
                      </div>
                      <div className=" flex switch:hidden relative group">
                        <NextImage
                          width={100}
                          height={100}
                          alt="Image"
                          src={"/image_essential_one.svg"}
                          className=" h-[300px] break:h-[406px] w-full object-cover"
                        />
                        <div className=" absolute left-0 right-0 bottom-0 h-[20%] group-hover:h-full transition-all duration-200 w-full bg-gradient-to-t from-black to-transparent flex flex-col justify-end ps-2 switch:ps-5 pb-5">
                          <UnderlinedSubHeading>
                            <span>
                              SHOP <BarlowBoldText text="TENNIS EARRINGS" />
                            </span>
                          </UnderlinedSubHeading>
                        </div>
                      </div>
                      <div className=" relative group">
                        <NextImage
                          width={100}
                          height={100}
                          alt="Image"
                          src={"/image_tennis_rings.svg"}
                          className=" h-[300px] break:h-[406px] w-full object-cover"
                        />
                        <div className=" absolute left-0 right-0 bottom-0 h-[20%] group-hover:h-full transition-all duration-200 w-full bg-gradient-to-t from-black to-transparent flex flex-col justify-end ps-2 switch:ps-5 pb-5">
                          <UnderlinedSubHeading>
                            <span>
                              SHOP <BarlowBoldText text="TENNIS RINGS" />
                            </span>
                          </UnderlinedSubHeading>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className=" hidden switch:flex h-full items-end justify-end">
                    <div className=" relative w-full group">
                      <NextImage
                        width={100}
                        height={100}
                        alt="Image"
                        src={"/image_essential_one.svg"}
                        className=" h-[500px] break:h-[654px] w-full object-center"
                      />
                      <div className=" absolute left-0 right-0 bottom-0 h-[20%] transition-all duration-200 group-hover:h-full w-full bg-gradient-to-t from-black to-transparent flex flex-col justify-end ps-5 pb-5">
                        <UnderlinedSubHeading>
                          <span>
                            SHOP <BarlowBoldText text="TENNIS EARRINGS" />
                          </span>
                        </UnderlinedSubHeading>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
              {/* customization section */}

              {/* <ShopByMood /> */}
              {/* question section */}
              <QuestionSection />
              <VertelierLove />
            </div>
          ) : (
            <>
              {/* <CircularProgressbar /> */}
              <Loading
                classes={
                  'flex-grow flex relative max-h-screen mt-[25px] h-[585px]!bg-[rgba(128,128,128,0.3)]!text-white'
                }
              />
            </>
          )}
        </>
      ) : (
        <>{/* <CircularProgressbar /> */}</>
      )}
    </>
  )
}

type UnderlinedSubHeadingProps = {
  children: ReactNode
}
const UnderlinedSubHeading = ({ children }: UnderlinedSubHeadingProps) => {
  return (
    <h2 className=' hover:cursor-pointer text-sub-heading mb-lg:text-[14px] switch:text-[16px] lg:text-[20px] font-barlowNormal underline uppercase tracking-[2px] cursor-pointer'>
      {children}
    </h2>
  )
}

type SubHeadingProps = {
  text: string
  styledText?: string
}

const SubHeading = ({ text, styledText }: SubHeadingProps) => {
  return (
    <button className='uppercase  tracking-[2px] text-start font-barlowSemibold  mb-lg:text-[16px] sm:text-[18px] md:text-[18px]'>
      {' '}
      {text} {styledText}
    </button>
  )
}

type BoldTextProp = {
  text: string
}
export const BarlowBoldText = ({ text }: BoldTextProp) => {
  return <span className=' font-barlowSemibold'>{text}</span>
}

type SubHeaderOneProp = {
  children: React.ReactNode
}
const SubHeaderOne = ({ children }: SubHeaderOneProp) => {
  return (
    <h2 className='text-center uppercase text-sub-heading mb-lg:text-[14px] sm:text-[16px] switch:text-[18px] md:text-[20px] tracking-[2px] text-black font-barlowNormal'>
      {children}
    </h2>
  )
}

export default NewLoveAffir
